module.exports = __webpack_public_path__ + "static/media/star.ba5dafbd.svg";